// This file is used to define all the API calls to the backend
import http, {
  responsePromiseChainHandler,
} from "../sitel/commons/services/http";

/**
 * Inits the ap with current user's exemptions
 * @param {*} successCallback
 * @param {*} errorCallback
 * @returns
 */
export function appInit(successCallback, errorCallback) {
  responsePromiseChainHandler(
    http.get(`/appinit`),
    successCallback,
    errorCallback
  );
}

/**
 * Current user exemptions. might need to delete
 */
/*MOVE TO ADMIN
export function exemption(target,successCallback,errorCallback){
    responsePromiseChainHandler(http.get(`/exemption/target/${target}`),successCallback,errorCallback);
}
*/
/**
 * Creates a new exemption request in "draft" status
 * @param {*} exemptionType
 * @param {*} successCallback
 * @param {*} errorCallback
 * @returns
 */
export function createRequest(ohrequestType, successCallback, errorCallback) {
  responsePromiseChainHandler(
    http.post("/ohrequest", { params: { ohrequestType } }),
    successCallback,
    errorCallback
  );
}

/**
 *
 * @param {int} requestId
 * @param {json} data
 * @param {callback} successCallback
 * @param {callback} errorCallback
 */
export function saveRequestFields(
  requestId,
  data,
  successCallback,
  errorCallback
) {
  responsePromiseChainHandler(
    http.patch(`/ohrequest/ohrequestid/${requestId}`, {
      params: { fields: data },
    }),
    successCallback,
    errorCallback
  );
}

/**
 * Called in final step of form. All data was filled and submitted
 * This will trigger an email to admins that a new request is awaiting their attention
 *
 * @param {*} imageData
 * @param {*} sigDate
 * @param {*} successCallback
 * @param {*} errorCallback
 */
export function submitRequest(
  requestId,
  imgData,
  signDate,
  successCallback,
  errorCallback
) {
  responsePromiseChainHandler(
    http.put(`/ohrequest/ohrequestid/${requestId}`, {
      params: { imgData, signDate },
    }),
    successCallback,
    errorCallback
  );
}

/**
 * Deletes a request with the given requestId.
 *
 * @param {string} requestId - The ID of the request to delete.
 * @param {function} successCallback - The callback function to be executed on successful deletion.
 * @param {function} errorCallback - The callback function to be executed on deletion error.
 */
export function deleteRequest(requestId, successCallback, errorCallback) {
  // Calls responsePromiseChainHandler with the delete request promise and the success and error callback functions.
  responsePromiseChainHandler(
    http.delete(`/ohrequest/ohrequestid/${requestId}`),
    successCallback,
    errorCallback
  );
}


/**
 * Creates a new upload entry in redis
 * @param {*} exemptionId
 * @param {*} fileName
 * @param {*} successCallback
 * @param {*} errorCallback
 * @returns
 */
export function createUploadCacheEntry(
  exemptionId,
  fileName,
  successCallback,
  errorCallback
) {
  responsePromiseChainHandler(
    http.post(`/documents/slice/cache`, { params: { exemptionId, fileName } }),
    successCallback,
    errorCallback
  );
}
/**
 * Creates a new upload record entry in the database
 * @param {*} exemptionId
 * @param {*} fileName
 * @param {*} tags
 * @param {*} successCallback
 * @param {*} errorCallback
 * @returns
 */
export function createUploadDBEntry(
  exemptionId,
  fileName,
  tags,
  successCallback,
  errorCallback
) {
  responsePromiseChainHandler(
    http.post(`/documents/slice/upload`, {
      params: { exemptionId, fileName, tags },
    }),
    successCallback,
    errorCallback
  );
}

/**
 * Get sas
 * Creates a new upload record entry in the database on upload completion
 * @param {*} ohrequestId
 * @param {*} userId
 * @param {*} fileName
 * @param {*} successCallback
 * @param {*} errorCallback
 * @returns
 */
export function getAzureSasToken(successCallback, errorCallback) {
  responsePromiseChainHandler(
    http.get(`/documents/slice/sas`),
    successCallback,
    errorCallback
  );
}

/**
 * Get user uploaded files
 * @param {*} userId
 * @param {*} requestId
 * @param {*} successCallback
 * @param {*} errorCallback
 * @returns
 */
export function getUploadedList(
  userId,
  ohrequestid,
  successCallback,
  errorCallback
) {
  responsePromiseChainHandler(
    http.get(
      `/documents/slice/list/userid/${userId}/ohrequestid/${ohrequestid}`
    ),
    successCallback,
    errorCallback
  );
}

/*
      export function createExemptionRequestUploadRecord(
        ohrequestId,
        userId,
        fileName,
        successCallback,
        errorCallback
        ) {
          responsePromiseChainHandler(
            http.post("/upload", {
              params: {
                ohrequestId,
                userId,
                fileName,
              },
            }),
            */

// /**
//  * NOT DONE YET - NEED TO ADD TO BACKEND
//  * Creates a new upload record entry in the database on upload completion
//  * @param {*} exemptionId
//  * @param {*} userId
//  * @param {*} fileName
//  * @param {*} successCallback
//  * @param {*} errorCallback
//  * @returns
//  */

// export function createExemptionRequestUploadRecord(
//   exemptionId,
//   userId,
//   fileName,
//   successCallback,
//   errorCallback
// ) {
//   responsePromiseChainHandler(
//     http.post("/upload", {
//       params: {
//         exemptionId,
//         userId,
//         fileName,
//       },
//     }),
//     successCallback,
//     errorCallback
//   );
// }
